export default __webpack_public_path__ + "static/2457-8a67035cbf2fc8e2317ddeb6df4c8a41.gif";